<template src="./templates/header.html"></template>

<script>
	export default {
		name: 'PageHeader'
	};
</script>

